import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';
import {handleTotalChecked, modalRenderCheckbox, modalRenderPillUnits, getCheckedFromDataTable} from '../../utilities/productsModalUtilities';
import render from "../../utilities/render";

const elementsMap = {
  originFacility: '.origin-facility',
  addProductsFromlistBtn: '.add-products-modal-btn',
  selectedProductsTable: '.selected-products-table',
  tableResponsiveCreateOrderTable: "#product-tab-transfer-ord-table",
  productEmptyTableValidator: '#products-empty-table-validator',
  addProductsBtn: '.add-products-btn',
  productItemLookup: "#product-item-lookup"
};

export default function ProductsTab(wizard, addProductsModal){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  const doc = $(document);
  const modalCheckboxSelector = ".order-modal-checkbox";
  let modalOrderTable =  null;

  self.productItems = {};
  self.productNameArr = {};

  self.init = function(){
    updateSelf();
  };

  self.didNavigateToForm = function() {
    handleDisplayOfCreateOrderTable();
  };

  self.isValid = function(){
    return getItemsInCreateOrderTable().length;
  };

  function updateSelf(){
    setElements();
    setWidgets();
    bindElements();
  }

// Instantiate Modal Flow
  const loadingProductListModal = new SubmitModalFlow({
    confirmModalTitle: 'Loading Product List'
  });
  // Init Flow
  loadingProductListModal.init();

  function setElements() {
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function setWidgets() {
    instantiateSkuTypeAhead();
    const productItemLookup = els.productItemLookup;
    productItemLookup.on("select2:select", function() {
        var res = productItemLookup.select2('data')[0].text.split("--");
        addProducts(res[0],res[1],res[2],res[3]);
        triggerAddProductsEvent();
        productItemLookup.val(null).trigger('change');
    });
  }

  function instantiateSkuTypeAhead(){

    const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      processResults: function (data, params) {
        params.page = params.page || 1;
        return {
          results: getProductNamesAndItems(data),
          pagination: {
            more: (params.page * 20) < data.total_count
          }
        };
      },
      cache: true
    };

    function configureDataCallback({paramKey}){
      return function(params){
        return {
          [paramKey] : params.term,
          "facId": els.originFacility.val()
        };
      };
    }

    els.productItemLookup.select2({
      placeholder: "Type product name (SKU)",
      allowClear: true,
      ajax: {
        ...select2AjaxDefaults,
        url: wizardElement.data("get-product-names-and-items-url"),
        data: configureDataCallback(
          {
            paramKey: 'likeSku'
          }
        )
      },
      minimumInputLength: 3
    });

  }

  function bindElements() {
    /*els.originFacility.on("change", function(){
      let facIdLocal = els.originFacility.val();
      if(!isBlank(facIdLocal)) {
        getProductNamesAndItems(facIdLocal);
      }
    });*/

    els.addProductsFromlistBtn.on("click", showAddProductsModal);
    els.selectedProductsTable.on('addedproducts', handleAddProducts);
    els.addProductsBtn.on("click", handleAddProductsBtnFromModal);
    doc.on('click', '#order-transfer-wizard .products-tab .icon-remove', handleItemRemove);
  }

  var triggerAddProductsEvent = function(){
    els.selectedProductsTable.trigger('addedproducts');
  }

  function showAddProductsModal(e) {
    e.preventDefault();
    showProductModal();
  }

  function showProductModal(){
    addProductsModal.modal("show");
    unCheckAllInModal();
    handleTotalChecked(addProductsModal, modalOrderTable, modalCheckboxSelector);
  }

  function unCheckAllInModal(){
    const checkBoxes = getCheckedFromDataTable(modalOrderTable, modalCheckboxSelector);
    checkBoxes.prop("checked", false);
  }

    //add-up how many Checkboxes are checked!
  $(document).on("change", modalCheckboxSelector, function() {
    handleTotalChecked(addProductsModal, modalOrderTable, modalCheckboxSelector);
  });

  function handleAddProducts(){
    EditChecker.setPageDirty();
    handleDisplayOfCreateOrderTable();
    $(els.productEmptyTableValidator).trigger("qwcustomchange");
  }

  function handleItemRemove(e){
    EditChecker.setPageDirty();
    //removeClosestRow($(e.target));
    //change the method name to remove product related rows.
    removeProductRelatedRows($(e.target));
    handleDisplayOfCreateOrderTable();
    $(els.productEmptyTableValidator).trigger("qwcustomchange");
  }

  function removeProductRelatedRows(el) {
    const coreProduct = el.closest('tr');
    removeProductRelatedRowsFromTr(coreProduct);
  }

  function removeProductRelatedRowsFromTr(coreProduct){
    const childProducts = coreProduct.data("childProducts");
    if(childProducts && childProducts.length) {
      _(childProducts).map(function(childProduct) {
        childProduct.remove();
      })
    }
    coreProduct.remove();
  }

  function removeProductRelatedRowsFromTrs(coreProducts){
    coreProducts.each(function(){
    removeProductRelatedRowsFromTr($(this));
    });
  }

  function handleDisplayOfCreateOrderTable(){
    if(getItemsInCreateOrderTable().length){
      show(els.selectedProductsTable);
    }else{
      hide(els.selectedProductsTable);
    }
  }

  function hide(el){
    el.css({display: "none"});
  }
  function show(el){
    el.css({display: "block"});
  }

  function getItemsInCreateOrderTable(){
    return els.selectedProductsTable.find('tbody tr');
  }

  function getProductNamesAndItems(response) {
    //els.tableResponsiveCreateOrderTable.find('tbody > tr').remove();
    // Show Loading Modal
    //loadingProductListModal.showLoadingModal();
    //loadingProductListModal.hideAllModals();
    let productNameArr = response.productNameArr;
    //self.productNameArr.regularItems = productNameArr;
    //let items = response.items;
    //self.productItems.regularItems = items;
    return productNameArr;
  }

  self.setProductLookupAndModal = function(items,productNameArr)
  {
      modalOrderTable =  addProductsModal.find('.modal-order-table').dataTable();
      modalOrderTable.fnClearTable();

      if(items != null && items.length > 0){
        modalOrderTable.fnAddData(items);

      }
  };

  function getCheckedRowsFromDataTable(dt, selector){
    const checkedRows = _($(dt.api().rows().nodes()).toArray()).filter(function(tr){
      return !!$(tr).find(`${selector}:checked`).length;
    })
    return $(checkedRows);
  }

  function handleAddProductsBtnFromModal() {
    const allCheckedRows = getCheckedRowsFromDataTable(modalOrderTable, modalCheckboxSelector);
    var skus = allCheckedRows.map(function () {
      return $(this).find("td").eq(2).text()}).get();

    var productNames = allCheckedRows.map(function () {
      return $(this).find("td").eq(1).text()}).get();

    var availUnit = allCheckedRows.map(function () {
      return $(this).find("td").eq(3).text()}).get();

    var prdType = allCheckedRows.map(function () {
      return $(this).find("td").eq(4).text()}).get();

    for (var i=0;i<skus.length;i++) {
      addProducts(productNames[i],skus[i],availUnit[i],prdType[i]);
    }
    triggerAddProductsEvent();

  addProductsModal.modal("hide");
  }

  var addProducts = function(productName,prodDescription,availUnit,prdType) {
    var highestId = parseInt($("#product-tab-transfer-ord-table tbody tr:last").attr("id"));
    if(isNaN(highestId)){
      highestId = 0;
    }else{
      ++highestId;
    }

    const productRow = $(render(
      require("./html/productViews.html"),{
        highestId: highestId,
        productName: productName,
        prodDescription: prodDescription,
        availUnit: availUnit,
        portletNamespace: portletNamespace
      }
    ));

    $("#product-tab-transfer-ord-table").find('tbody').append(productRow);
  }
}



// WEBPACK FOOTER //
// ./src/pages/transferOrder/ProductsTab.js